import { HTMLAttributes, default as React } from "react";

import { tv, VariantProps } from "tailwind-variants";

export const badgeStyles = tv({
  base: "flex h-fit w-fit flex-row items-center justify-center rounded-xl border-1 border-white-600 bg-white-800 px-2 text-sm",
  variants: {
    disabled: {
      true: "cursor-not-allowed opacity-50",
    },
    color: {
      blue: "",
      purple: "",
      white: "",
      yellow: "",
      red: "",
      green: "",
    },
    size: {
      big: "text-base",
      regular: "text-base",
      small: "text-sm",
      tiny: "text-xs",
    },
  },
  compoundVariants: [
    {
      color: "blue",
      className: "text-blue-50",
    },
    {
      color: "purple",
      className: "text-purple-50",
    },
    {
      color: "white",
      className: "hover:bg-white-100",
    },
    {
      color: "yellow",
      className: "text-yellow-50",
    },
    {
      color: "red",
      className: "text-red-50",
    },
    {
      color: "green",
      className: "text-green-50",
    },
  ],
});

type Variants = VariantProps<typeof badgeStyles>;
export type BadgeVariants = Required<Omit<Variants, "disabled">> & Pick<Variants, "disabled">;

type BadgeProps = HTMLAttributes<HTMLDivElement> &
  BadgeVariants & {
    children: React.ReactNode;
  };

export const Badge = ({ color, size, disabled, children, className }: BadgeProps) => {
  return <div className={badgeStyles({ color, size, disabled, className })}>{children}</div>;
};
